import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ScrollView } from '../../../../common/components/atoms';
import { HeaderTitle } from '../../../components/molecues';

import icon_up from '../../../components/atoms/data/icon_up.svg';
import icon_down from '../../../components/atoms/data/icon_down.svg';

class Faq extends Component {
    constructor(props) {
        super(props);
        this.refScroll = React.createRef();
        this.state = {
            current: 7,
            faqList: [],
            faq: {title: "", contents: ""},
            infoContentsDisplay: [],
        }
    }
    componentDidMount() {
		this.props.dispatch({
            type: "LoadEnd"
        });
        this.faqReload();
    }
    faqReload = () => {
        this.props.dispatch({
            type: "GetFaqList_Saga",
            onSuccess: this.onSuccessGetFaqList,
            onFailure: this.onFailure,
        });
    }
    onSuccessGetFaqList = (list) => {
        this.setState({ faqList: list });
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickInfo(e, index) {
        let infoContentsDisplay = this.state.infoContentsDisplay;
        infoContentsDisplay[index] = !this.state.infoContentsDisplay[index];
        this.setState({ 
            infoContentsDisplay: infoContentsDisplay,
        });
    }
    createContents() {
        let faq = [];
        let infoContentsDisplay = [];
        for (let key in this.state.faqList) {
            infoContentsDisplay[key] = false;
            faq.push(
                <React.Fragment key={key+"fragment"}>
                <FaqTitle key={key} onClick={e => this.onClickInfo(e, key)}> 
                    <TitleText>
                        {this.state.faqList[key].question}
                    </TitleText>
                    <InfoRight>
                        {this.state.infoContentsDisplay[key] ? 
                            <img alt="ecprime-logo" src={icon_up} width="30px"  />
                            : <img alt="ecprime-logo" src={icon_down} width="30px"  />}
                    </InfoRight>
                </FaqTitle>
                <FaqContents key={key+"contents"} Selectable={true} displayFaqDlg={this.state.infoContentsDisplay[key]}  dangerouslySetInnerHTML={{ __html: this.state.faqList[key].answer }} />
                </React.Fragment>
            )
        }
        return faq;
    }
    onClickHome = () => {
        this.props.history.replace('/home');
    }
    render() {
        const propsScroll = {
            width: '100%',
            height: (window.innerHeight  - 64) + "px",
            contents: this.createContents()
        };
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
        };
        return (
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <ScrollView ref={this.refScroll}  {...propsScroll} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
    }
};

const connectedFaq = connect(mapStateToProps)(Faq);
export { connectedFaq as Faq };

const Body = styled.div`
`;
const FaqTitle = styled.div`
    margin: 5px;
    display: flex;
    background-color: #e2f0d9;
    justify-content: center;
`;
const TitleText = styled.div`
    width: 90%;
    padding: 10px 5px 10px 20px;
    font-size:15px;
    font-weight: bold; 
`;
const InfoRight = styled.div`
    margin: auto 5px;
    color: #00b050;
    font-size: 25px;
    font-weight: normal;
`;
const FaqContents = styled.div`
    width:93%;
    display: ${props => props.displayFaqDlg ? '':'none'};
    word-break: break-all;
    padding: 5px 10px;
`;